import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card,Box, CardContent, Typography, Grid, CardActionArea } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faHandshake, faExchangeAlt, faChartPie, faRedoAlt, faMoneyCheckAlt, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'; // Add suitable icons
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/constants'; // Ensure this path is correct
import BackButton from '../../components/BackButton';

// Define the report data as a constant
const reportData = [
  {
    title: 'Total Collection',
    icon: faDollarSign,
    path: 'total-collection',
    modules: [3910],
  },
  {
    title: 'Total Commission',
    icon: faHandshake,
    path: 'total-commissions',
    modules: [3911],
  },
  {
    title: 'Total Transactions',
    icon: faExchangeAlt,
    path: 'transactions',
    modules: [3912],
  },

  // {
  //   title: 'Welfare Amount',
  //   icon: faCoins,
  //   path: 'welfare-amount',
  //   modules: [1514],
  // },
  // {
  //   title: 'Reduce Welfare',
  //   icon: faCoins,
  //   path: 'reduce-welfare',
  //   modules: [1515],
  // },
  {
    title: 'Change Commis..',
    icon: faRedoAlt,
    path: 'commission-reset',
    modules: [3914],
  },
  {
    title: 'AceMoney Trans.',
    icon: faMoneyCheckAlt,
    path: 'acemoney-transactions',
    modules: [3915],
  },
  {
    title: 'Shop Wallet Report',
    icon: faFileInvoiceDollar,
    path: 'wallet-report',
    modules: [3915],
  },
  {
    title: 'Merchants Advance Fund Report',
    icon: faFileInvoiceDollar,
    path: 'advance-fund-report',
    modules: [3915],
  },
]; 

const ManageShopReport = () => {
  const [userModules, setUserModules] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Decode the JWT and store the user level and userId
    const token = sessionStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);

      if (decodedToken.level === 1 ) {
        // If user is SuperAdmin or Admin, grant access to all modules
        setUserModules(reportData.flatMap(report => report.modules));
      } else {
        // Otherwise, fetch the modules from the privileges stored in the backend
        fetchUserPrivileges(decodedToken.userId);
      }
    }
  }, []);

  const fetchUserPrivileges = async (userId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/privileges/modules/${userId}`);
      if (response.status === 200 && response.data.modules) {
        setUserModules(response.data.modules);
      } else {
        console.error('Failed to fetch user privileges or no modules found');
      }
    } catch (error) {
      console.error('Error fetching user privileges:', error);
    }
  };

  // Handler for card click
  const handleCardClick = (path) => {
    if (path === 'total-collection') navigate('/shop-report/total-collection');
    else if (path === 'transactions') navigate('/shop-report/transactions');
    else if (path === 'advance-fund-report') navigate('/shop-report/advance-fund-report');
    else navigate(`/shop-report/${path}`);
  };

  // Function to check if the user has access to a specific module
  const hasAccess = (modules) => {
    return modules.some(moduleId => userModules.includes(moduleId));
  };

  return (
    <Box sx={{ position: 'relative', padding: 2 }}>
    {/* Place BackButton outside the Grid */}
    <BackButton />
    <br/>  <br/>
    <Grid container spacing={3}  alignItems="center">
      {reportData.map((report) => (
        hasAccess(report.modules) && (
          <Grid item xs={12} sm={6} md={4} key={report.title}>
            <Card
              elevation={3}
              sx={{
                maxWidth: 225,
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '& .MuiTypography-root': {
                    color: 'white !important',
                  },
                  '& .fa-icon': {
                    color: 'white !important',
                  },
                },
              }}
            >
              <CardActionArea onClick={() => handleCardClick(report.path)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <FontAwesomeIcon
                    icon={report.icon}
                    size="5x"
                    className="fa-icon"
                    style={{ color: 'orange' }}
                  />
                  <Typography gutterBottom variant="h5" component="div" sx={{ marginTop: 2 }}>
                    {report.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        )
      ))}
    </Grid>
    </Box>
  );
};

export default ManageShopReport;
